import RequestPageTwo from "./RequestPageTwo";

const MaintenanceReq = () => {
    return (
        <RequestPageTwo title="Maintenance Reqests"
            fetchUrl="/get-maintenance-requests"
            editEndpoint="update-maintenance-requests"
            deleteEndpoint="maintenance-requests"
            statusEndpoint="update-maintenance-requests" />
    );
}

export default MaintenanceReq;
